import AboutPage from "@/components/about/AboutPage"
import { PageMeta } from "@/components/common/Seo/PageMeta"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "About us",
        description:
          "Token Terminal turns raw blockchain data into institutional-grade financial metrics for investors, researchers and builders. Learn about our mission and team.",
      }}
    />
    <AboutPage />
  </>
)

export default index
